import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import vuexI18n from 'vuex-i18n'

import users from "./users.module"
import vouchers from "./vouchers.module"
import courses from "./courses.module"
import tutorproducts from "./tutorproducts.module"
import auth from "./auth.module";
import stripe from "./stripe.module"
import translations from "./translations.module"
import globals from "./global.module"
import modules from './modules.module'
import languages from "./languages.module"
import equipment from "./equipment.module"
import roles from "./roles.module"
import groups from "./groups.module"
import documents from "./documents.module"
import pages from './pages.module'
import companysettings from './companysettings.module'
import dashboard from './dashboard.module'
import reminderemail from './reminderemail.module'
import videotutorial from './videotutorial.module'
import equipmentgroups from './equipmentgroups.module'
import equipmenttemplate from './equipmenttemplate.module'
import testcasegroup from './testcasegroup.module'
import testcasetemplate from './testcasetemplate.module'
import equipmentlabels from './equipmentlabels.module'
import testcase from './testcase.module'
import questions from './questions.module'
import quiz from './quiz.module'
import answers from './answers.module'
import useranswers from './useranswers.module'
import permissions from './permissions.module'
import customrole from './customrole.module'
import emailtemplates from './emailtemplates.module'
import scheduledemailtemplates from './scheduledemailtemplates.module'
import triggeredemailtemplates from './triggeredemailtemplates.module'
import stats from './stats.module'
import additionalpage from './additionalpages.module'
import surveys from "./survey.module"
import testexams from "./testexams.module"
import exercises from "./exercises.module"
import calendars from "./calendars.module"

import translationsEn from '../locale/en'
import translationsDe from '../locale/de'


Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    users,
    auth,
    vouchers,
    courses,
    tutorproducts,
    stripe,
    documents,
    pages,
    groups,
    languages,
    equipment,
    companysettings,
    equipmentgroups,
    equipmenttemplate,
    equipmentlabels,
    testcase,
    roles,
    modules,    
    translations,
    globals,
    testcasegroup,
    testcasetemplate,
    videotutorial,
    reminderemail,
    questions,
    answers,
    quiz,
    useranswers,
    dashboard,
    customrole,
    permissions,
    emailtemplates,
    scheduledemailtemplates,
    triggeredemailtemplates,
    stats,
    additionalpage,
    surveys,
    testexams,
    exercises,
    calendars,
  }
})


Vue.use(vuexI18n.plugin, store);
Vue.i18n.add('en', translationsEn)
Vue.i18n.add('de', translationsDe)

export default store